import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Button, Modal, Form, Col } from 'react-bootstrap';
import { UserService } from '../../services/';

const RequestPasswordResetModal = (props) => {
    const [userName, setUsername] = useState('');
    const [errorText, setErrorText] = useState(null);
    let history = useHistory();

    const sendResetPasswordRequest = async () =>  {
        var userService = new UserService();
        var result = await userService.requestPasswordReset(userName);
        if (result.result) {
            // successful
            props.closeModal();
        } else {
            var error = result.hasErrors ? result.errors.join(', ') : result.message;
            setErrorText(error);
        }
    }

    return (
        <>
            <Modal.Header><b>Request password reset</b></Modal.Header>
            <Modal.Body>
                <p>Please enter your username and press the <b>Send</b> button.  A temporary passcode
                    will be emailed, along with a reset link, which will allow you to reset your password.</p>
                <Form.Row>
                    <Form.Group as={Col} lg="12" md="12" controlId="name">
                        <Form.Label>Username</Form.Label>
                        <Form.Control isInvalid={errorText} placeholder="" name="userName" id="userName" value={userName} onChange={e => setUsername(e.target.value)} />
                        <Form.Control.Feedback type="invalid">
                            {errorText}
                        </Form.Control.Feedback>
                    </Form.Group>
                </Form.Row>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="light" onClick={() => props.closeModal()}>Dismiss</Button>
                <Button variant="primary" disabled={userName.length === 0} onClick={sendResetPasswordRequest}>Send</Button>
            </Modal.Footer>
        </>
    );
};

export default RequestPasswordResetModal